// import logo from './logo.svg';
import React, { Suspense } from 'react';
import './App.less';
import { ConfigProvider } from 'antd';

import { Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';

// React.lazy 和 Suspense 技术不支持服务端渲染。想要在使用服务端渲染的应用中使用，使用 Loadable Components 这个库。它有一个很棒的服务端渲染打包指南
import moment from 'moment';
import 'moment/locale/zh-cn';

import zhCN from 'antd/lib/locale/zh_CN';
const Home = React.lazy(() => import('./views/home/index.js'));
const About = React.lazy(() => import('./views/about/index.js'));
const Ypshop = React.lazy(() => import('./views/ypsxYpShop/index.js'));
const CanvasPage = React.lazy(() => import('./views/canvas_pages/index.js'));
const Drag = React.lazy(() => import('./views/drag/index.js'));
moment.locale('en');
function App() {
  console.log('app1');
  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        <div>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/about" exact strict element={<About />}></Route>
              <Route
                path="/canvasPage"
                exact
                strict
                element={<CanvasPage />}
              ></Route>
              <Route path="/ypshop" exact strict element={<Ypshop />}></Route>

              <Route path="/drag" exact strict element={<Drag />}></Route>
              <Route path="/home" exact strict element={<Home />}></Route>
              <Route path="/" element={<Navigate to="/home" />} />
            </Routes>
          </Suspense>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default App;
